module.exports = __webpack_public_path__ + "static/media/gradient-spinner.f73e8b80.png";